import React from 'react';
import {
  Modal,
  Text,
  BlockStack,
  InlineStack,
  Badge,
} from '@shopify/polaris';

const StoryDetailsModal = ({ 
  isOpen, 
  onClose, 
  selectedStory 
}) => {
  if (!selectedStory) return null;

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={selectedStory.title}
      primaryAction={{
        content: 'Close',
        onAction: onClose,
      }}
    >
      <BlockStack gap="400">
        <Text variant="bodyMd">{selectedStory.description}</Text>
        <InlineStack gap="200">
          <Badge>{selectedStory.gender}</Badge>
          <Badge>{selectedStory.age}</Badge>
          <Badge>{selectedStory.language}</Badge>
        </InlineStack>
      </BlockStack>
    </Modal>
  );
};

export default StoryDetailsModal; 